import React from "react";
import SegmentDefaultsContainer from "../../containers/segments-defaults/SegmentDefaultsContainer";

const SegmentsDefaults = () => {
  return <SegmentDefaultsContainer />;
};

export default SegmentsDefaults;
